import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=15e0e468&scoped=true&"
import script from "./PasswordReset.vue?vue&type=script&lang=ts&"
export * from "./PasswordReset.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=15e0e468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e0e468",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VForm,VIcon,VImg,VTextField})
